<template>
  <div class="aspirante" v-if="store.state.spinner === 0">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-10 col-lg-10">
          <h2>Aspirante {{ store.state.name }} {{store.state.primerApellido}} </h2>
          <p>Leer la siguiente información con atención, está a punto de comenzar la prueba técnica para la
            siguiente categoría de licencia :</p>
          <h4>{{ store.state.categoriaLicencia }}</h4>
          <p>El contenido de la prueba corresponde a 40 preguntas de selección múltiple que evalúan sus
            actitudes. En la siguiente pantalla
            le estaremos compartiendo ayudas para la comprensión y actividades a proceder en el examen, para
            tener en cuenta.
          </p>
          <div class="continuar">
            <input name="continuar" type="button" id="button" value="INGRESO AYUDAS EXAMEN" @click.prevent="store.commit('setSpinner',1)" @click="ingresarExamen" >
          </div>


        </div>
      </div>
    </div>
  </div>

  <div class="spinner">
    <div class="loadingio-spinner-spin-heo5mdcsoq4" v-if="store.state.spinner === 1">
      <div class="ldio-j0m93sdo0rp" >
        <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
      </div>
  </div>
</div>
</template>
  
<script >
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification';
import store from '@/store'
import axios from 'axios'

export default {
  data() {
    return {
    }
  },
  setup() {
    //Uso del store
    const store = useStore();
    const toast = useToast();

    return {
      store, toast
    }
  },

  methods: {
    async ingresarExamen() {

      //Servicio para obtener preguntas
      const idUser = this.$store.state.idUsuario;
      try {
        const { data } = await axios.get(
          `https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-examen-teorico/examen-teorico/${idUser}`
        );
        store.commit('setPreguntas', data);
        store.commit('setNumberQuestions', data.length);
        store.commit('setIdExamenTeorico', data[0].idExamenTeorico);
        store.commit('setidExamenEjecucion', data[0].idExamenEjecucion)
        // console.log(data[0].urlMultimediaPregunta)
       
        // let vari = data[0]
        //  console.log(vari.hasOwnProperty('pregunta'));
        this.estadoHabilitacion();


        return data[0]

      } catch ($error) {
        console.log($error, 'An error has ocurred');
        store.commit('setSpinner', 0)
        this.toast.error("Ha ocurrido un error, por favor inténtalo nuevamente", {
          timeout: 5000,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          closeOnClick: false
        });
      }

    },

    //Servicio para obtener estado de habilitación del examen
    async estadoHabilitacion() {
      const idUser = this.$store.state.idUsuario;

      // obtener el nombre del mes, día del mes, año, hora   
      let moment = require('moment');
      let now = moment().format("YYYY-MM-DD HH:mm:ss ");
      // console.log(now)

      //Agregar fecha actual a la petición
      try {
        const { data } = await axios.get(
          `https://ansv-func-licencias-qa-apim.azure-api.net/ANSV-func-licencias-qa-examen-teorico/ConsultarHabilitacionExamenTeorico/${idUser}/${now}`
          
        );
        // console.log(data)
        store.commit('setSpinner', 0)
        this.$router.push('/pruebas')
        return data[0]

      } catch ($error) {
        console.log($error, 'An error has ocurred');
        store.commit('setSpinner', 0)
        this.toast.error("Ha ocurrido un error, por favor inténtalo nuevamente", {
          timeout: 5000,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          closeOnClick: false
        });
      }
    }
  }
}

</script>
  
<style lang="scss" >
@import '../fonts/fonts.scss';

.aspirante {
  font-family: 'Montserrat', sans-serif;
  background: #f0f0f0;
  padding-top: 5%;
  padding-bottom: 5%;
  font-size: 16px;
  color: #4B4B4B;

  .modal {
    position: fixed;
    z-index: 999;
    top: 20%;
    left: 50%;
    width: 300px;
    margin-left: -150px;
  }

  h3 {
    font-size: 26px;
    padding-bottom: 2%;
    color: #323232;

  }

  h4 {
    font-size: 22px;
    padding-bottom: 1%;
    color: #323232;
  }

  .continuar {
    justify-content: center;
    align-items: center;
    display: flex;

    #button {
      height: 34px;
      width: 238px;
      font-size: 14px;
      margin-top: 3%;
      border-radius: 15px;
      border: none;
      background-color: #071D49;
      color: #FFFFFF;

      &:hover {
        background-color: #00b5e2;

      }
    }
  }

}

//Loader
@keyframes ldio-j0m93sdo0rp {
  0% {
    opacity: 1;
    backface-visibility: hidden;
    transform: translateZ(0) scale(1.5,1.5);
  } 100% {
    opacity: 0;
    backface-visibility: hidden;
    transform: translateZ(0) scale(1,1);
  }
}
.spinner {
  justify-content: center;
  align-items: center;
  display: flex;
}
.ldio-j0m93sdo0rp div > div {
  position: absolute;
  width: 60.480000000000004px;
  height: 60.480000000000004px;
  border-radius: 50%;
  background: #1d0e0b;
  animation: ldio-j0m93sdo0rp 0.9174311926605504s linear infinite;
}.ldio-j0m93sdo0rp div:nth-child(1) > div {
  left: 373px;
  top: 222px;
  animation-delay: -0.8027522935779816s;
}
.ldio-j0m93sdo0rp > div:nth-child(1) {
  transform: rotate(0deg);
  transform-origin: 403.24px 252.24px;
}.ldio-j0m93sdo0rp div:nth-child(2) > div {
  left: 329px;
  top: 329px;
  animation-delay: -0.6880733944954128s;
}
.ldio-j0m93sdo0rp > div:nth-child(2) {
  transform: rotate(45deg);
  transform-origin: 359.24px 359.24px;
}.ldio-j0m93sdo0rp div:nth-child(3) > div {
  left: 222px;
  top: 373px;
  animation-delay: -0.573394495412844s;
}
.ldio-j0m93sdo0rp > div:nth-child(3) {
  transform: rotate(90deg);
  transform-origin: 252.24px 403.24px;
}.ldio-j0m93sdo0rp div:nth-child(4) > div {
  left: 115px;
  top: 329px;
  animation-delay: -0.4587155963302752s;
}
.ldio-j0m93sdo0rp > div:nth-child(4) {
  transform: rotate(135deg);
  transform-origin: 145.24px 359.24px;
}.ldio-j0m93sdo0rp div:nth-child(5) > div {
  left: 71px;
  top: 222px;
  animation-delay: -0.3440366972477064s;
}
.ldio-j0m93sdo0rp > div:nth-child(5) {
  transform: rotate(180deg);
  transform-origin: 101.24000000000001px 252.24px;
}.ldio-j0m93sdo0rp div:nth-child(6) > div {
  left: 115px;
  top: 115px;
  animation-delay: -0.2293577981651376s;
}
.ldio-j0m93sdo0rp > div:nth-child(6) {
  transform: rotate(225deg);
  transform-origin: 145.24px 145.24px;
}.ldio-j0m93sdo0rp div:nth-child(7) > div {
  left: 222px;
  top: 71px;
  animation-delay: -0.1146788990825688s;
}
.ldio-j0m93sdo0rp > div:nth-child(7) {
  transform: rotate(270deg);
  transform-origin: 252.24px 101.24000000000001px;
}.ldio-j0m93sdo0rp div:nth-child(8) > div {
  left: 329px;
  top: 115px;
  animation-delay: 0s;
}
.ldio-j0m93sdo0rp > div:nth-child(8) {
  transform: rotate(315deg);
  transform-origin: 359.24px 145.24px;
}
.loadingio-spinner-spin-heo5mdcsoq4 {
  width: 504px;
  height: 504px;
  display: inline-block;
  overflow: hidden;
  background: #ffff;
}
.ldio-j0m93sdo0rp {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; 
}
.ldio-j0m93sdo0rp div { box-sizing: content-box; }
</style>